// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"38aa6ad4","446":"0d0ed75b","529":"d0ecde60","543":"7486aba1","846":"a6df9177","989":"4aa733c9"}[chunkId] + ".chunk.js";
};